export function StatusBadge({
  status,
  children,
}: {
  status: "published" | "draft" | "active" | "inactive";
  children: string;
}) {
  return <span className={`status status--${status}`}>{children}</span>;
}
